(() => {
if (window.__staffStylingIndex) return;
window.__staffStylingIndex = true;
let shared;
const parse = html => new DOMParser().parseFromString(html.replace(/<img\b[^>]*>/gi,tag=>tag.replace(/\s(src|srcset)\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi,(_,name,value)=>' data-styling-'+name.toLowerCase()+'='+value)), 'text/html');
function restoreImages(node){node.querySelectorAll('img').forEach(image=>{image.loading='lazy';for(const attr of ['srcset','src']){const value=image.getAttribute('data-styling-'+attr);if(value){image.setAttribute(attr,value);image.removeAttribute('data-styling-'+attr)}}});return node}
function near(root,start){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();start()}},{rootMargin:'250px'});observer.observe(root);return ()=>observer.disconnect()}
async function read(url) {
 const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(12000)});
 if (!response.ok) throw new Error('Styling could not be loaded');
 return parse(await response.text());
}
function themed(path, theme) {
 const url = new URL(path, location.origin);
 if (url.origin !== location.origin) throw new Error('Invalid styling source');
 const preview = new URL(location.href).searchParams.get('preview_theme_id');
 if (preview) url.searchParams.set('preview_theme_id', preview);
 else if (window.Shopify?.designMode && theme) url.searchParams.set('preview_theme_id', theme);
 return url;
}
async function load(root) {
 const url=themed(root.dataset.source,root.dataset.theme);
 const doc=await read(url);
 const grid=doc.querySelector('.styling-index__grid');
 if(!grid)throw new Error('Styling index is unavailable');
 return {cards:Array.from(grid.querySelectorAll('[data-central-look]')),failed:false,fresh:true};
}

const subscribers = new Set();
const cacheKey = root => '1618-styling-v3|' + root.dataset.theme + '|' + root.dataset.root + '|' + document.documentElement.lang;
function saved(root) {
 try {
  const data=JSON.parse(sessionStorage.getItem(cacheKey(root)));
  if(data && Array.isArray(data.html) && Date.now()-data.time < 60000) {
   return {cards:data.html.map(html=>parse(html).querySelector('.ss-card')).filter(Boolean),failed:false};
  }
 } catch {}
 return null;
}
function observe(root, callback) {
 subscribers.add(callback);
 const cached=saved(root);
 if(cached?.cards.length)callback(cached);
 if(!shared)shared=load(root).then(result=>{
  if(!result.failed) {
   try {sessionStorage.setItem(cacheKey(root),JSON.stringify({time:Date.now(),html:result.cards.map(card=>card.outerHTML)}));} catch {}
  }
  subscribers.forEach(fn=>fn(result));
  return result;
 }).catch(error=>{
  console.warn('Staff styling index:',error.message);
  subscribers.forEach(fn=>fn({cards:[],failed:true}));
 });
 else shared.then(result=>callback(result)).catch(()=>{});
 return ()=>subscribers.delete(callback);
}
function alignItemRows(grid) {
 const cards=Array.from(grid.querySelectorAll('[data-central-look]')).filter(card=>!card.hidden);
 const rows=Math.max(1,...cards.map(card=>card.querySelector('.ss-items')?.children.length || 0));
 grid.style.setProperty('--styling-item-rows',String(rows));
}
function staffName(card) {
 const name = card.querySelector('.ss-name')?.cloneNode(true);
 name?.querySelectorAll('small').forEach(node => node.remove());
 return name?.textContent.trim() || 'STAFF';
}
function portalImage(original) {
 const image=original.cloneNode(true);for(const attr of ['srcset','src']){const value=image.getAttribute('data-styling-'+attr);if(value){image.setAttribute(attr,value);image.removeAttribute('data-styling-'+attr)}}
 image.removeAttribute('id');
 image.loading='lazy';
 image.sizes='(min-width:1440px) 440px, (min-width:750px) 33vw, 50vw';
 return image;
}
class StylingIndex extends HTMLElement {
 connectedCallback() {
  if(this.loaded)return;this.loaded=true;
  const grid=this.querySelector('.styling-index__grid');
  const select=this.querySelector('select');
  const update=()=>{
   let count=0;
   grid.querySelectorAll('.ss-card').forEach(card=>{card.hidden=!!select.value && card.dataset.staff!==select.value;if(!card.hidden)count++;});
   this.querySelector('.styling-index__count').textContent=count+' LOOKS';
   alignItemRows(grid);
  };
  select.addEventListener('change',update);
  const render=({cards,failed,fresh})=>{
   this.dataset.stylingState=fresh?'updated':'cached';
   if(cards.length || !failed) {
    const selected=select.value;
    const names=new Set();
    grid.replaceChildren();
    select.replaceChildren(new Option('ALL STAFF',''));
    for(const original of cards) {
     const card=original.cloneNode(true);
     card.removeAttribute('data-shopify-editor-block');
     card.dataset.staff=staffName(card);
     names.add(card.dataset.staff);
     card.querySelectorAll('.ss-media img').forEach(image=>{image.loading='lazy';image.sizes='(min-width:1440px) 440px, (min-width:750px) 33vw, 50vw';});
     grid.append(card);
    }
    for(const name of names)select.append(new Option(name,name));
    if(names.has(selected))select.value=selected;
    update();
   }
   const status=this.querySelector('.styling-index__status');
   status.hidden=grid.childElementCount>0;
   status.textContent=failed?'スタイリングを読み込めませんでした。ページを再読み込みしてください。':'スタイリングは準備中です。';
  };
  render({cards:Array.from(grid.querySelectorAll('.ss-card')),failed:false});
  // The index is rendered directly from the central registry by Liquid.

 }
 disconnectedCallback(){this.stopNear?.();this.stop?.();this.loaded=false;}
}
class StylingPortal extends HTMLElement {
 connectedCallback() {
  if(this.loaded)return;this.loaded=true;
  const photos=this.querySelector('.styling-portal__photos');
  const initial=photos.querySelectorAll('img').length;
  if(initial)photos.style.gridTemplateColumns='repeat('+Math.min(3,initial)+',minmax(0,1fr))';
  this.stopNear=near(this,()=>{this.stop=observe(this,({cards,failed,fresh})=>{
   this.dataset.stylingState=fresh?'updated':'cached';
   if(!cards.length){if(!failed)photos.replaceChildren();return;}
   photos.replaceChildren();
   photos.style.gridTemplateColumns='repeat('+Math.min(3,cards.length)+',minmax(0,1fr))';
   cards.slice(0,3).forEach(card=>{const image=card.querySelector('.ss-media img');if(image)photos.append(portalImage(image))});
  });});
 }
 disconnectedCallback(){this.stopNear?.();this.stop?.();this.loaded=false;}
}
class StylingProduct extends HTMLElement {
 connectedCallback(){
  if(this.loaded)return;this.loaded=true;
  const pid=this.dataset.product;
  const categories=(this.dataset.collections||'').split('|').filter(Boolean);
  const grid=this.querySelector('.styling-index__grid');
  const previous=this.querySelector('[data-styling-prev]');
  const next=this.querySelector('[data-styling-next]');
  const controller=new AbortController();this.events=controller;
  const updateNavigation=()=>{
   const overflow=grid.scrollWidth>grid.clientWidth+2;
   previous.disabled=!overflow || grid.scrollLeft<2;
   next.disabled=!overflow || grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2;
  };
  const scroll=direction=>grid.scrollBy({left:direction*(grid.clientWidth+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  previous.addEventListener('click',()=>scroll(-1),{signal:controller.signal});
  next.addEventListener('click',()=>scroll(1),{signal:controller.signal});
  grid.addEventListener('scroll',updateNavigation,{passive:true,signal:controller.signal});
  this.resizeObserver=new ResizeObserver(updateNavigation);this.resizeObserver.observe(grid);
  this.stopNear=near(this.previousElementSibling||this.parentElement,()=>{this.stop=observe(this,({cards,failed})=>{
   if(failed)return;
   const matches=cards.filter(card=>card.dataset.products?.includes('|'+pid+'|') || categories.some(id=>card.dataset.collections?.includes('|'+id+'|')));
   grid.replaceChildren();
   matches.forEach((card,index)=>{
    const clone=card.cloneNode(true);clone.removeAttribute('data-shopify-editor-block');clone.removeAttribute('id');
    clone.querySelectorAll('.ss-items,.ss-items-label,.ss-category-note,.ss-comment,.ss-ig').forEach(el=>el.remove());
    clone.style.gridColumn=String(Math.floor(index/4)*2+index%2+1);
    clone.style.gridRow=String(Math.floor(index%4/2)+1);
    const link=document.createElement('a');link.href=this.dataset.root+'pages/staff-styling#look-'+encodeURIComponent(card.dataset.centralLook);
    link.setAttribute('aria-label',(staffName(card)||'STAFF')+'のスタイリングを見る');
    const media=clone.querySelector('.ss-media');
    link.append(...media.childNodes);media.append(link);
    const hint=document.createElement('small');hint.className='styling-product__category-hint';hint.textContent=card.dataset.products?.includes('|'+pid+'|')?'':'同カテゴリーの着用例';clone.querySelector('.ss-info').append(hint);
    const more=document.createElement('a');more.className='styling-product__look-link';more.href=link.href;more.textContent='VIEW LOOK →';
    clone.querySelector('.ss-info').append(more);
    const items=card.querySelectorAll('.ss-item');
    if(items.length){
     const destinations=document.createElement('ul');destinations.className='styling-product__shop-links';destinations.setAttribute('aria-label','着用商品・カテゴリー');
     items.forEach(item=>{
      const original=item.querySelector('.ss-item-title');
      if(!original?.getAttribute('href'))return;
      const entry=document.createElement('li');
      const destination=document.createElement('a');destination.href=original.getAttribute('href');
      const kind=document.createElement('small');kind.textContent=item.classList.contains('ss-category-item')?'同カテゴリーの商品を見る':'着用商品を見る';
      const title=document.createElement('span');title.textContent=original.textContent.trim();
      destination.append(kind,title);
      const arrow=document.createElement('span');arrow.className='styling-product__shop-arrow';arrow.textContent='→';arrow.setAttribute('aria-hidden','true');destination.append(arrow);
      entry.append(destination);
      if(item.querySelector('.ss-soldout')){const sold=document.createElement('small');sold.className='styling-product__soldout';sold.textContent='完売 / 商品ページで関連商品を見る';entry.append(sold);}
      destinations.append(entry);
     });
     clone.querySelector('.ss-info').append(destinations);
    }
    clone.querySelectorAll('.ss-media img').forEach(image=>image.sizes='(min-width:1440px) 640px, (min-width:750px) 45vw, 45vw');
    grid.append(restoreImages(clone));
   });
   this.dataset.stylingCount=String(matches.length);
   this.querySelector('.styling-product__actions').hidden=matches.length<=4;
   this.hidden=!matches.length;
   updateNavigation();
  });});
 }
 disconnectedCallback(){this.stopNear?.();this.stop?.();this.events?.abort();this.resizeObserver?.disconnect();this.loaded=false;}
}
customElements.define('staff-styling-product',StylingProduct);
customElements.define('staff-styling-index',StylingIndex);
customElements.define('staff-styling-portal',StylingPortal);
})();